import React from 'react'

const RentalListings = () => {
  return (
    <div>RentalListings</div>
  )
}

export default RentalListings